
























































import { AuditObjectTypeEnum } from '@empathybroker/tsclient-play/dist/enums/audit-object-type.enum';

import { Component } from 'vue/types/options';

import { ColorEnum, FeatureIdEnum } from '../../enums';

import Badge from '../badge.component.vue';
import { UiIconButton, UiTooltip } from '../keen-ui';
import TransitionHeight from '../transition-height.component.vue';
import AuditDetails from './details/audit-details.component.vue';
import ConfigurationAuditDetails from './details/configuration-audit-details.component.vue';

export default {
  name: 'audit-entry',
  props: {
    audit: {
      type: Object,
      required: true
    },
    expanded: Boolean,
    messages: {
      type: Object,
      required: true
    }
  },
  components: {
    Badge,
    UiTooltip,
    UiIconButton,
    TransitionHeight,
    AuditDetails
  },
  computed: {
    objectTypeColor: function (): ColorEnum {
      const colorOptions = {
        [AuditObjectTypeEnum.SYNONYM]: () => ColorEnum.BLUE,
        [AuditObjectTypeEnum.SEARCH_CONFIGURATION]: () => ColorEnum.ORANGE,
        default: () => ColorEnum.PRIMARY
      };
      return (colorOptions[this.audit.payload.objectType] || colorOptions.default)();
    },
    objectTypeText: function (): string {
      const featureNames = this.$epb.messages.app.features;
      const textOptions = {
        [AuditObjectTypeEnum.EQUALIZE]: () => featureNames[FeatureIdEnum.EQUALIZE],
        [AuditObjectTypeEnum.BLACKLIST]: () => featureNames[FeatureIdEnum.BLACKLIST],
        [AuditObjectTypeEnum.PRODUCTS_RANKING]: () => featureNames[FeatureIdEnum.PRODUCTS_RANKING],
        [AuditObjectTypeEnum.ATTRIBUTES_RANKING]: () => featureNames[FeatureIdEnum.ATTRIBUTES_RANKING],
        [AuditObjectTypeEnum.PROMOTION]: () => featureNames[FeatureIdEnum.PROMOTION],
        [AuditObjectTypeEnum.REDIRECTION]: () => featureNames[FeatureIdEnum.REDIRECTION],
        [AuditObjectTypeEnum.SYNONYM]: () => featureNames[FeatureIdEnum.SYNONYM],
        [AuditObjectTypeEnum.BROWSE_CONFIGURATION]: () => featureNames[FeatureIdEnum.CONFIGURATION],
        [AuditObjectTypeEnum.SEARCH_CONFIGURATION]: () => featureNames[FeatureIdEnum.CONFIGURATION],
        [AuditObjectTypeEnum.INSTANCE]: () => featureNames[FeatureIdEnum.INSTANCE],
        default: () => this.audit.payload.objectType
      };
      return (textOptions[this.audit.payload.objectType] || textOptions.default)();
    },
    detailsComponent: function (): Component {
      const componentOptions = {
        [AuditObjectTypeEnum.SEARCH_CONFIGURATION]: ConfigurationAuditDetails,
        [AuditObjectTypeEnum.BROWSE_CONFIGURATION]: ConfigurationAuditDetails,
        default: AuditDetails
      };
      return (componentOptions[this.audit.payload.objectType] || componentOptions.default);
    }
  },
  data: function () {
    return {
      ColorEnum
    };
  }
};
